export default {
  // mode: 'dark',
  mode: 'light',
  bodyOverscroll: false,
  color: {
    primary: '#0860ac',
    black: '#000000',
    white: '#ffffff',
    danger: '#ce3829',
    'btn-active': "#1877bf",
    'blue-950': "#00539c",
    'blue-900': "#0860ac",
    'blue-700': "#1877bf",
    'blue-500': "#0585d3",
    'blue-300': "#52a8e8",
    'blue-100': "#71b6eb",
    'blue-50': "#a1d3f9",
    'blue-30': "#c8e6ff",
    'blue-10': "#f2f8fd",
    'blue-gr-300': "#006ecd",
    'blue-gr-100': "#2eabdf",
    'gray-950': "#0c0c0c",
    'gray-900': "#373737",
    'gray-700': "#808080",
    'gray-500': "#bfc0c1",
    'gray-300': "#e2e2e2",
    'gray-100': "#f5f5f5",
    'white-100': "#f4f6ff",
    'white-50': "#fafafa",
    'red-900': "#b72f22",
    'red-700': "#ce3829",
    'red-500': "#dd4e41",
    'red-300': "#e66155",
    'red-100': "#ffc4bf",
    'red-50': "#ffdedb",
    'red-10': "#ffeeec",
    'yellow-900': "#e8b400",
    'yellow-700': "#f3cb00",
    'yellow-500': "#ffd500",
    'yellow-300': "#ffe147",
    'yellow-100': "#ffe97a",
    'yellow-50': "#fbf0b6",
    'yellow-10': "#fff7d0",
    'green-900': "#16815c",
    'green-700': "#2a9a73",
    'green-500': "#35b487",
    'green-300': "#59be9b",
    'green-100': "#acddcc",
    'green-50': "#e5f4ef",
    'orange-900': "#da8400",
    'orange-700': "#eb9613",
    'orange-500': "#f9a422",
    'orange-300': "#f6b147",
    'orange-100': "#fbc674",
    'orange-50': "#fbe0b6",
    'pink-light': "#d8d8d8",
  },
}